<template>
  <v-app>
    <v-navigation-drawer app clipped persistent v-model="showDrawer">
      <v-list dense>
        <v-list-item-group>
          <v-list-item v-for="(item, i) in menu" :key="i" :to="{name: item.route}" exact>
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group>
          <v-list-item>
            <v-list-item-icon>
              <v-icon></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>v{{ version }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app v-if="showToolbar" clipped-left clipped-right fixed elevation="2">
      <v-app-bar-nav-icon @click.stop="showDrawer = !showDrawer"></v-app-bar-nav-icon>
      <v-toolbar-title v-if="!isMobile" style="min-width: 200px;">Connect My Church</v-toolbar-title>
        <v-list-item :to="{name: 'organizations'}" :disabled="!showOrgSelect" >
          <v-text-field
          v-if="showOrgSelect"
          disabled
          dense
          hide-details
          label="Active Organization"
          outlined
          placeholder="Select an Organization"
          :value="selectedOrganization.name"
          >
          </v-text-field>
        </v-list-item>

        <v-list-item :to="{name: 'sites'}" :disabled="!showSiteSelect">
          <v-text-field
          v-if="showSiteSelect"
          disabled
          dense
          hide-details
          label="Active Site"
          outlined
          placeholder="Select a Site"
          :value="selectedSite.name"
          >
          </v-text-field>
        </v-list-item>
      <v-spacer></v-spacer>
      <v-menu offset-y v-if="!isMobile">
        <template v-slot:activator="{ on }">
          <v-btn icon text v-on="on"><v-icon x-large>account_circle</v-icon></v-btn>
        </template>
        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { removeCookie } from 'tiny-cookie'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import { version } from '../../package.json'

export default {

  data () {
    return {
      forms: [],
      showDrawer: true,
      showToolbar: true,
      sites: [],
      version: version
    }
  },

  computed: {
    ...mapGetters([
      'isOrgAdmin',
      'isOrganizationSelected',
      'isSiteSelected',
      'selectedOrganization',
      'selectedSite',
      'getUser'
    ]),

    isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly
    },

    showOrgSelect: function () {
      return this.getUser.memberships.superAdmin || (this.getUser.memberships.organizations.length > 1)
    },

    showSiteSelect: function () {
      return (this.isOrganizationSelected &&
      (this.getUser.memberships.sites.length > 1 || this.getUser.memberships.superAdmin)) ||
      !this.isOrgAdmin
    },

    menu: function () {
      var menu = [
        {
          icon: 'home',
          title: 'Home',
          route: 'home'
        },
        {
          icon: 'done',
          title: 'My Pending Approvals',
          route: 'actions'
        }
      ]

      if (this.isOrgAdmin) {
        menu.push({
          icon: 'account_balance',
          title: 'Organizations',
          route: 'organizations'
        })
      }

      menu.push({
        icon: 'business',
        title: 'Sites',
        route: 'sites'
      })

      if (this.isSiteSelected) {
        menu.push(
          {
            icon: 'history',
            title: 'Site Pending Requests',
            route: 'actionsPending'
          },
          {
            icon: 'trending_up',
            title: 'Reports',
            route: 'reports'
          },
          {
            icon: 'group',
            title: 'Users',
            route: 'users'
          },
          {
            icon: 'favorite',
            title: 'Interests',
            route: 'interests'
          }
        )
      }

      if (this.getUser.memberships.superAdmin) {
        menu.push(
          {
            icon: 'build',
            title: 'Interest Defaults',
            route: 'interestdefaults'
          },
          {
            icon: 'grading',
            title: 'Logs',
            route: 'logs'
          }
        )
      }

      return menu
    }
  },

  mounted () {
    this.actionGetUser()
  },

  watch: {
    filters: function () {
      this.updatePath()
    },

    '$route.name': function () {
      this.updatePath()
    },

    getUser: function () {
      if (this.getUser.memberships.sites.length === 1) {
        ApiRequests.siteGet(this.getUser.memberships.sites[0].resource).then(r => {
          this.setSite(r.data)
        })
      }
    }
  },

  methods: {
    ...mapMutations([
      'setSite'
    ]),

    ...mapActions([
      'actionGetUser'
    ]),

    updatePath: function () {
      if (this.selectedSite && this.selectedSite._id) {
        var query = Object.assign({}, this.$route.query)
        if (query.site !== this.selectedSite._id) {
          query.site = this.selectedSite._id
          this.$router.replace({
            name: this.$route.name,
            query: query
          })
        }
      }
    },

    logout: function () {
      ApiRequests.logoutPost().then(response => {
        removeCookie('token')
      }).catch(e => {
        console.error(e)
        // This appears twice and in the request repsonse so that there is no race condition
        // between deleting the cookie and sending the request that requires it
        removeCookie('token')
      })
      this.$router.push({ name: 'login' })
    }

  }
}
</script>

<style>
.container {
  padding-bottom: 8px;
  padding-top: 8px;
  padding-left: 8px;
  padding-right: 8px;
}

#addButton {
  overflow: hidden;
  position: fixed;
  bottom: 20px !important;
  right: 20px;
}

.card-header {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
</style>
